/* eslint-disable */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ILayout, selectDisplayLayout } from '@/store/slices/layoutSlice';
import { alpha, AppBar, Box, IconButton, Stack, Toolbar, Button, Tooltip, Chip, Avatar } from '@mui/material';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import { MHidden } from "@/components/@material-extend";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { selectDrawer, setDrawer } from "@/store/slices/appSlice";
import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import LanguageSelector from "@/components/language-selector";
import AccountPopover from "@/components/account-popover/AccountPopover";

// import avatarIcon from '@iconify/icons-eva/options-2-outline';
import ClientWizard from "@/features/clients/create";
import CreateProduct from "@/features/products/create";

import { Link as RouterLink, useHistory } from 'react-router-dom';
import UserRFC from './components/UserRFC';
import UserCredits from "./components/UserCredits";
import { selectCurrentUser, selectIsRegisterCompleted } from "@/store/slices/authSlice";
import { getRegisterStatus } from "@/helpers/local-storage";

const DRAWER_WIDTH = 170;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 78;

const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
    backgroundColor: alpha('#fff', .1),
    [theme.breakpoints.up('lg')]: {
        width: `calc(100% - ${DRAWER_WIDTH}px)`
    }
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const MuiAppBar = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    width: `calc(100% - ${theme.spacing(5)})`,
    backgroundColor: alpha('#fff', 0.1),
    backdropFilter: 'blur(16.8px)',
    boxShadow: 'none',
    ...(open && {
        marginLeft: DRAWER_WIDTH,
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: APPBAR_DESKTOP,
        padding: theme.spacing(0, 2)
    }
}));

type HeaderProps = {
    onOpenSidebar: () => void;
}

// icono del wizard
const iconClient = (
    <Tooltip title={'Agregar cliente'}>
        <Button aria-label="add" sx={{ color: 'primary.main' }}>
            <img src={'/static/images/topbar/add-client.svg'} height={55} alt="" />
        </Button>
    </Tooltip>
);

const iconProduct = (
    <Tooltip title={'Agregar producto'}>
        <Button aria-label="add" sx={{ color: 'primary.main' }}>
            <img src={'/static/images/topbar/add-producto.svg'} height={55} alt="" />
        </Button>
    </Tooltip>
);

const Header = ({ onOpenSidebar }: HeaderProps): any => {
    const layout: ILayout = useSelector(selectDisplayLayout);
    const drawer: boolean = useSelector(selectDrawer);

    const dispatch = useDispatch();
    // current user logged
    const user: any = useSelector(selectCurrentUser);

    // obtener user scopes
    const role: string = user?.roles[0];

    // obtener si ya completó registro
    const register_complete: boolean = getRegisterStatus();
    const register_complete_stored: boolean = useSelector(selectIsRegisterCompleted);
    const handleDrawer = () => {
        dispatch(setDrawer(!drawer));
    }

    if (!layout.header) {
        return null;
    }

    const history = useHistory();

    // add customer
    const modalAddClient = <ClientWizard isModal={true} icon={iconClient} isHeaderBtn from={"main header"} />

    // add product
    const modalAddProduct = <CreateProduct isModal={true} icon={iconProduct} isHeaderBtn from={"main header"} />

    return (
        <>
            <MHidden width="lgUp">
                <RootStyle>
                    <ToolbarStyle>
                        <MHidden width="lgUp">
                            <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: '#4d5050' }}>
                                <Icon icon={menu2Fill} />
                            </IconButton>
                        </MHidden>
                        {((role && role !== 'SuperAdminRole') && (register_complete || register_complete_stored)) &&
                            (
                                <>
                                    <Tooltip title={'Crear factura'}>
                                        <Button
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disableElevation
                                            component={RouterLink}
                                            to={'/create/invoice'}
                                        >
                                            <img src={`/static/images/sidebar-icons/create-invoice.svg`} height={70} width={70} />
                                        </Button>
                                    </Tooltip>
                                    {/* <Tooltip title={'Crear pago'}>
                                        <Button
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disableElevation
                                            component={RouterLink}
                                            to={'/create/pay'}
                                        >
                                            <img src={`/static/images/sidebar-icons/create-payment.svg`} height={50} width={50} />
                                        </Button>
                                    </Tooltip> */}
                                </>
                            )
                        }

                        {
                            (role && role !== 'SuperAdminRole') &&
                            <>
                                {/* {modalAddClient} */}
                                {modalAddProduct}
                            </>
                        }
                        <MHidden width="lgDown">
                            <IconButton onClick={handleDrawer} sx={{ mr: 1, color: '#4d5050' }}>
                                <Icon icon={menu2Fill} />
                            </IconButton>
                        </MHidden>

                        <Box sx={{ flexGrow: 1 }} />

                        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
                            <UserCredits />
                            <LanguageSelector />
                            {/* <UserRFC /> */}
                            <AccountPopover />
                        </Stack>

                    </ToolbarStyle>
                </RootStyle>
            </MHidden>

            <MHidden width="lgDown">
                {/*style={{ ...headerStyle }}*/}
                <MuiAppBar open={drawer}>
                    <ToolbarStyle>
                        <MHidden width="lgUp">
                            <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: '#4d5050' }}>
                                <Icon icon={menu2Fill} />
                            </IconButton>
                        </MHidden>

                        {/* <MHidden width="lgDown">
                            <IconButton onClick={handleDrawer} sx={{ mr: 1, color: '#FFF' }}>
                                <Icon icon={menu2Fill} />
                            </IconButton>
                        </MHidden> */}

                        {((role && role !== 'SuperAdminRole') && (register_complete || register_complete_stored)) &&
                            (
                                <>
                                    <Tooltip title={'Crear factura'}>
                                        <Button
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disableElevation
                                            component={RouterLink}
                                            to={'/create/invoice'}
                                        >
                                            <img src={`/static/images/sidebar-icons/create-invoice.svg`} height={70} width={70} />
                                        </Button>
                                    </Tooltip>
                                    {/* <Tooltip title={'Crear pago'}>
                                        <Button
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disableElevation
                                            component={RouterLink}
                                            to={'/create/pay'}
                                        >
                                            <img src={`/static/images/sidebar-icons/create-payment.svg`} height={50} width={50} />
                                        </Button>
                                    </Tooltip> */}
                                </>
                            )
                        }

                        {
                            (role && role !== 'SuperAdminRole') &&
                            <>
                                {modalAddClient}
                                {modalAddProduct}
                            </>
                        }

                        {/* {modalAddProduct}
                        {modalAddProduct} */}

                        <Box sx={{ flexGrow: 1 }} />
                        <Stack direction="row" alignItems="center" spacing={{ xs: 1, sm: 3 }}>
                            <LanguageSelector />
                            {/* <Chip
                                avatar={<img alt="" src="/static/images/topbar/credits.svg" />}
                                label={`N/D`}
                                variant="outlined"
                                size="medium"
                                sx={
                                    {
                                        p: 1,
                                        border: 'none',
                                        fontWeight: 'bold',
                                    }
                                }
                            /> */}
                            <UserCredits />
                            <UserRFC />
                            <AccountPopover />
                        </Stack>
                    </ToolbarStyle>
                </MuiAppBar>
            </MHidden>

        </>
    );
};

Header.propTypes = {
    onOpenSidebar: PropTypes.func
};

export default Header;
